class Controller {
  constructor($mdDialog, backup, Backup, StationsTransforms) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.backup = backup;

    Backup.nearBy(backup).$promise.then((response) => {
      this.nearByStations = StationsTransforms.justify(response.hits);
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide({ station: this.selectedStation });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backup/scheduleStationDialog/scheduleStationDialog.controller.js